import { useEffect } from "react";
import { useMap } from "react-leaflet";

export interface ZoomLayerControlProps {
  showRadar?: boolean;
  showForecast?: boolean;
}

export const ZoomLayerControl = ({
  showRadar,
  showForecast,
}: ZoomLayerControlProps) => {
  const map = useMap();

  useEffect(() => {
    const zoom = map.getZoom();

    // Rainbow AI radar has maxZoom of 7
    if (showRadar) {
      if (zoom > 7) {
        map.setZoom(7);
      }
    } else if (showForecast) {
      // Forecast layers have maxZoom of 10
      if (zoom >= 11) {
        map.setZoom(10);
      }
    }
  }, [map, showRadar, showForecast]);

  return null;
};
